import * as React from "react";
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import ActiveList from "./ActiveList";
import WaitingOnYou from "./WaitingOnYou";
import WaitingOnOthers from "./WaitingOnOthers";
import ErrorMsg from "./home/ErrorMsg";
import * as Tools from "../../helpers/Tools";
import Spinner from "../common/spinner";
import { PROXY_APPROVED, PROXY_DECLINED, EPIC, RX, PENDING_STATUS, APPROVED_STATUS, EXPIRED_STATUS, CANCELLED_STATUS, DECLINED_STATUS, REQUESTV2 } from "../../constants/textConstants";
import GrantDisclaimerModal from '../proxyManagement/grantAccess/GrantDisclaimerModal';
import { Typography, Button } from "../ecosystem";
import FamilyManagementCard from "./FamilyManagementCard";
import LinkRecord from "./home/LinkRecord";
import MedicalManagers from "./home/MedicalManagers";
import RXManagers from "./home/RXManagers";
const NOTAUTHORIZED = "You are not authorized to approve this request. The requester can resend the request if you feel this is an error.";
const UNABLETOAPPROVE = "We're sorry, we currently are unable to approve this request.";

const UNABLETODECLINE = "We're sorry, we currently are unable to decline this request.";

class MyProxies extends React.Component {
    constructor(props) {
        super(props);
        this.approvedRequest = null;
        this.declinedRequest = null;
        this.state = {
            declinedRequest: null,
            showGrantDisclaimerModal: false,
            agreedGrantDisclaimer: false
        };
        this.grantAccess = this.grantAccess.bind(this);
        this.onAgreeGrantDisclaimer = this.onAgreeGrantDisclaimer.bind(this);
    }

    componentDidMount() {
        this.props.setTimeoutMessage('');
        logUI("MBHWeb.UI.MyProxies.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
    }

    onApprove(request) {
        const { changeRequestStatus } = this.props;
        logUI("MBHWeb.UI.MyProxies.ApproveProxyRequest", new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: request.ProxyRequestId }));
        this.approvedRequest = request;
        this.declinedRequest = null;
        this.setState({ declinedRequest: null });
        this.props.setTimeoutMessage(PROXY_APPROVED);
        changeRequestStatus(request.ProxyRequestId, request.ProxySource, request.RequestType, PROXY_APPROVED);
    }

    onDecline(request) {
        logUI("MBHWeb.UI.MyProxies.DeclineProxyRequest", new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: request.ProxyRequestId }));
        this.approvedRequest = null;
        this.declinedRequest = request;
        const { declineProxyWithReason } = this.props;
        if (declineProxyWithReason) {
            this.setState({ declinedRequest: request });
        }
        else {
            this.props.setTimeoutMessage(PROXY_DECLINED);
            this.props.changeRequestStatus(request.ProxyRequestId, request.ProxySource, request.RequestType, PROXY_DECLINED);
        }
    }

    getDeclineErrorMessage(rsp) {
        let errorMessage = null;
        if (rsp && typeof rsp === "string") {
            switch (rsp) {
                case "Internal Server Error":
                    errorMessage = UNABLETODECLINE;
                    break;
                case "Conflict":
                    errorMessage = "This request has already been processed.";
                    break;
                default:
                    errorMessage = UNABLETODECLINE;
                    break;
            }
        }
        else if (rsp && rsp.message) {
            errorMessage = "You are not authorized to decline this request"; //this is not applicable but having it.
        }
        else {
            errorMessage = rsp;
        }

        return errorMessage;
    }

    // Get Error Message from changeRequestStatus response.
    getErrorMessage(status, rsp) {
        let errorMessage = null;
        if (status === 'failure') {
            if (rsp && typeof rsp === "string") {
                switch (rsp) {
                    case "Internal Server Error":
                        errorMessage = UNABLETOAPPROVE;
                        break;
                    case "Conflict":
                        errorMessage = "This request has already been processed.";
                        break;
                    default:
                        errorMessage = UNABLETOAPPROVE;
                        break;
                }
            }
            else if (rsp && rsp.message) {
                errorMessage = NOTAUTHORIZED;
            } else if (rsp && typeof (rsp) === "object" && !rsp.message) {
                errorMessage = UNABLETOAPPROVE;
            }
            else {
                errorMessage = rsp;
            }
        }
        return errorMessage;
    }

    grantAccess() {
        const { hasPharmacyLogin, hasMychartLogin } = this.props;
        if (hasMychartLogin && hasPharmacyLogin) {
            this.props.history.push("/grantaccessProxy");
        }
        this.setState({
            showGrantDisclaimerModal: true
        });
    }

    onAgreeGrantDisclaimer(agreed) {
        const { hasPharmacyLogin, hasMychartLogin } = this.props;
        this.setState({ agreedGrantDisclaimer: agreed });
        if (agreed) {
            this.props.history.push("/grantaccessProxy");
        }
        else {
            logUI(`MBHWeb.UI.GrantDisclaimerModal.OnClose`, new Date(), Tools.getURLPath(), { "healthrecord": hasMychartLogin, "pharmacy": hasPharmacyLogin, "agreed": false, "fromProxyDashboard": true });
        }
        this.setState({ showGrantDisclaimerModal: false });
    }

    render() {
        const { list, hasPharmacyLogin, hasMychartLogin, epicManagerList, showAccessAndProxiesList, grantPharmacyList, grantEpicList,
            changeRequestStatusAction, age, showGrantProxyAccess, actionType, epicManagerFailure, pharmacyError, emailProxyRequestId, emailProxyRequestErrMsg,
            enableProxyGrantPharmacy, enableProxyRequestV2, requestEpicList, enableProxyRXRequestAttestation } = this.props;

        // Set ApproveRequest for showing Approval status message on email proxy request
        if (emailProxyRequestId && !emailProxyRequestErrMsg) {
            this.approvedRequest = list && list.filter(account => account.ProxyRequestId && typeof account.ProxyRequestId === 'string' && account.ProxyRequestId.toLowerCase() === emailProxyRequestId)[0];
            this.declinedRequest = null;
        }

        {/*pharmacy proxy: managers(approved proxies)/pending proxy requests of your account.*/ }
        const pendingList = list && list.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        const hasPendingList = pendingList && pendingList.length > 0;
        let activeList = list && list.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);

        //Pending Grant pharmacy list.
        const pendingGrantPharmacyList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        const hasPendingGrantPharmacyList = pendingGrantPharmacyList && pendingGrantPharmacyList.length > 0;

        //Cancelled Grant Pharmacy list.
        const cancelledGrantPharmacyList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        const hasCancelledGrantPharmacyList = cancelledGrantPharmacyList && cancelledGrantPharmacyList.length > 0;

        //Declined Grant Pharmacy List.
        const declinedGrantPharmacyList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === DECLINED_STATUS);
        const hasDeclinedGrantPharmacyList = declinedGrantPharmacyList && declinedGrantPharmacyList.length > 0;

        //Expired Grant Pharmacy List.
        const expiredGrantPharmacyList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        const hasExpiredGrantPharmacyList = expiredGrantPharmacyList && expiredGrantPharmacyList.length > 0;

        //Pending Grant medicalrecords list.
        const pendingGrantEpicList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        const hasPendingGrantEpicList = pendingGrantEpicList && pendingGrantEpicList.length > 0;

        //Approved Grant pharmacy list.
        let grantPharmacyActiveList = grantPharmacyList && grantPharmacyList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);
        const hasGrantPharmacyActiveList = grantPharmacyActiveList && grantPharmacyActiveList.length > 0;

        //Approved Grant medicalrecords list.
        let grantEpicActiveList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);
        const hasGrantEpicActiveList = grantEpicActiveList && grantEpicActiveList.length > 0;

        //Cancelled Grant medicalrecords list.
        let grantEpicCancelledList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        const hasGrantEpicCancelledList = grantEpicCancelledList && grantEpicCancelledList.length > 0;

        //Declined Grant medicalrecords list.
        let grantEpicDeclinedList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === DECLINED_STATUS);
        const hasGrantEpicDeclinedList = grantEpicDeclinedList && grantEpicDeclinedList.length > 0;

        //Expired Grant medicalrecords list.
        let grantEpicExpiredList = grantEpicList && grantEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        const hasGrantEpicExpiredList = grantEpicExpiredList && grantEpicExpiredList.length > 0;

        //active list request epic
        let requestEpicActiveList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === APPROVED_STATUS);
        const hasRequestEpicActiveList = requestEpicActiveList && requestEpicActiveList.length > 0;

        //Pending Request Medical Reocrds List.
        let requestEpicPendingList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === PENDING_STATUS);
        const hasRequestEpicPendingList = requestEpicPendingList && requestEpicPendingList.length > 0;

        //Cancelled Request Medical Records lsit.
        let requestEpicCancelledList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        const hasRequestEpicCancelledList = requestEpicCancelledList && requestEpicCancelledList.length > 0;

        //Expired Request Medical Records
        let requestEpicExpiredList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        const hasRequestEpicExpiredList = requestEpicExpiredList && requestEpicExpiredList.length > 0;

        //Declined Request Medical List
        let requestEpicDeclinedList = requestEpicList && requestEpicList.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === DECLINED_STATUS);
        const hasRequestEpicDeclinedList = requestEpicDeclinedList && requestEpicDeclinedList.length > 0;

        //Cancelled Request v2 pharmacy Records.
        let requestRxCancelledList = list && list.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === CANCELLED_STATUS);
        const hasRequestRxCancelledList = requestRxCancelledList && requestRxCancelledList.length > 0;

        //Expired Request v2 pharmacy Records
        let requestRxExpiredList = list && list.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === EXPIRED_STATUS);
        const hasRequestRxExpiredList = requestRxExpiredList && requestRxExpiredList.length > 0;

        //Declined Request v2 pharmacy List
        let requestRxDeclinedList = list && list.filter(account => account.Status && typeof account.Status === 'string' && account.Status.toLowerCase() === DECLINED_STATUS);
        const hasRequestRxDeclinedList = requestRxDeclinedList && requestRxDeclinedList.length > 0;

        const epicActiveManagerList = (typeof epicManagerList !== "undefined") && epicManagerList;
        const hasEpicActiveManager = epicActiveManagerList && epicActiveManagerList.length > 0;

        const isChangeRequestActionApproveWaiting = changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_APPROVED && changeRequestStatusAction.waiting;
        const approvedRequestSuccess = changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_APPROVED && !changeRequestStatusAction.waiting &&
            this.approvedRequest && changeRequestStatusAction.request.proxyRequestId === this.approvedRequest.ProxyRequestId && changeRequestStatusAction.success;
        const approveRequestId = this.approvedRequest && this.approvedRequest.ProxyRequestId;

        //Show user approved request as top.
        if (approveRequestId && activeList && activeList.length > 0) {
            activeList.sort(function (x, y) { return x.ProxyRequestId === approveRequestId ? -1 : y.ProxyRequestId === approveRequestId ? 1 : 0; });
        }
        const hasActiveList = activeList && activeList.length > 0;

        const proxyErrorMsg = typeof (emailProxyRequestErrMsg) === "string" && emailProxyRequestErrMsg.toUpperCase() === "NOTAUTHORIZED" ? NOTAUTHORIZED : emailProxyRequestErrMsg;

        var approveErrorMessage = !emailProxyRequestErrMsg && changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_APPROVED ? this.getErrorMessage("failure", changeRequestStatusAction.error) : "";

        const isChangeRequestActionDeclineWaiting = changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_DECLINED && changeRequestStatusAction.waiting;
        const declineRequestId = this.declinedRequest && this.declinedRequest.ProxyRequestId;
        const declineErrorMessage = !emailProxyRequestErrMsg && changeRequestStatusAction && changeRequestStatusAction.request.status === PROXY_DECLINED ? this.getDeclineErrorMessage(changeRequestStatusAction.error) : "";
        const currentDeclinedRequest = this.state.declinedRequest;
        const declineRequestPathName = enableProxyRequestV2 && currentDeclinedRequest !== null && currentDeclinedRequest.RequestType && currentDeclinedRequest.RequestType !== "" && currentDeclinedRequest.RequestType.toLowerCase() === REQUESTV2 ? `/proxyrequest/decline/${declineRequestId}/${currentDeclinedRequest.ProxySource}/${window.btoa(currentDeclinedRequest.FirstName)}` : "/rx/declineproxy";

        return ((this.state.declinedRequest ? <Redirect to={{ pathname: declineRequestPathName, state: { declinedRequest: this.state.declinedRequest } }} /> :
            <div className="current__proxies">
                {showAccessAndProxiesList &&
                    <>
                    <FamilyManagementCard title="Medical">
                        {!hasMychartLogin
                            ? <LinkRecord
                                to={{
                                    pathname: '/linkedaccounts',
                                    searchParams: "openMyChart=true"
                                }}
                                />
                            : <MedicalManagers
                                showNoManagers={(showGrantProxyAccess
                                    ? (!hasGrantEpicActiveList && !hasRequestEpicActiveList)
                                    : (!hasEpicActiveManager && !epicManagerFailure) 
                                )}
                            >
                                {!showGrantProxyAccess && hasMychartLogin && hasEpicActiveManager &&
                                    <div className="row active-list-container">
                                        <div className="col-12">
                                            <ActiveList grantOrManagerList={epicActiveManagerList} proxySource={EPIC} />
                                        </div>
                                    </div>
                                }
                                {hasRequestEpicActiveList && hasMychartLogin &&
                                    <div className="row active-list-container">
                                        <div className="col-12">
                                            <ActiveList
                                                requestList={requestEpicActiveList}
                                                proxySource={EPIC} referrer="proxy"
                                                approvedRequest={this.approvedRequest}
                                                isApprovePending={isChangeRequestActionApproveWaiting}
                                                approveRequestId={approveRequestId}
                                                approvedRequestSuccess={approvedRequestSuccess}
                                                actionType={actionType}
                                            />
                                        </div>
                                    </div>
                                }
                                {showGrantProxyAccess && hasMychartLogin && hasGrantEpicActiveList &&
                                    <div className="row active-list-container">
                                        <div className="col-12">
                                            <ActiveList grantOrManagerList={grantEpicActiveList} proxySource={EPIC} referrer="acceptgrant" />
                                        </div>
                                    </div>
                                }

                                {enableProxyRequestV2 && hasMychartLogin && hasRequestEpicPendingList &&
                                    <div className="row pending-list-container">
                                        <div className="col-12">
                                            <WaitingOnYou
                                                list={requestEpicPendingList}
                                                onApprove={request => this.onApprove(request)}
                                                onDecline={request => this.onDecline(request)}
                                                proxySource={EPIC}
                                                isApprovePending={isChangeRequestActionApproveWaiting}
                                                approveRequestId={approveRequestId}
                                                approveErrorMessage={approveErrorMessage}
                                                isDeclinePending={isChangeRequestActionDeclineWaiting}
                                                declineRequestId={declineRequestId}
                                                declineErrorMessage={declineErrorMessage}
                                                actionType={actionType}
                                                history={this.props.history}
                                            />
                                        </div>
                                    </div>
                                }

                                {
                                    showGrantProxyAccess && hasMychartLogin && hasPendingGrantEpicList &&
                                    <div className="row pending-list-container">
                                        <div className="col-12">
                                            <WaitingOnOthers
                                                proxySource={EPIC}
                                                grantEpicPendingList={pendingGrantEpicList} />
                                        </div>
                                    </div>
                                }
                                {/* request v2 epic cancelled */}
                                {
                                    enableProxyRequestV2 && hasMychartLogin && hasRequestEpicCancelledList &&
                                    <div className="row cancelled-list-container">
                                        <div className="col-12">
                                            <WaitingOnYou
                                                proxySource={EPIC}
                                                hasRequestEpicCancelledList={hasRequestEpicCancelledList}
                                                requestEpicCancelledList={requestEpicCancelledList} />
                                        </div>
                                    </div>
                                }

                                {
                                    showGrantProxyAccess && hasMychartLogin && hasGrantEpicCancelledList &&
                                    <div className="row cancelled-list-container">
                                        <div className="col-12">
                                            <WaitingOnOthers
                                                proxySource={EPIC}
                                                grantEpicCancelledList={grantEpicCancelledList} />
                                        </div>
                                    </div>
                                }
                                {/* request v2 epic declined */}
                                {/*enableProxyRequestV2 && hasMychartLogin && hasRequestEpicDeclinedList &&
                                    <div className="row declined-list-container">
                                        <div className="col-12">
                                            <WaitingOnYou
                                                proxySource={EPIC}
                                                hasRequestEpicDeclinedList={hasRequestEpicDeclinedList}
                                                requestEpicDeclinedList={requestEpicDeclinedList} />
                                        </div>
                                    </div>
                                */}

                                {showGrantProxyAccess && hasMychartLogin && hasGrantEpicDeclinedList &&
                                    <div className="row declined-list-container">
                                        <div className="col-12">
                                            <WaitingOnOthers
                                                proxySource={EPIC}
                                                grantEpicDeclinedList={grantEpicDeclinedList} />
                                        </div>
                                    </div>
                                }
                                {/* request v2 epic expired */}
                                {enableProxyRequestV2 && hasMychartLogin && hasRequestEpicExpiredList &&
                                    <div className="row declined-list-container">
                                        <div className="col-12">
                                            <WaitingOnYou
                                                proxySource={EPIC}
                                                hasRequestEpicExpiredList={hasRequestEpicExpiredList}
                                                requestEpicExpiredList={requestEpicExpiredList} />
                                        </div>
                                    </div>
                                }

                                {showGrantProxyAccess && hasMychartLogin && hasGrantEpicExpiredList &&
                                    <div className="row declined-list-container">
                                        <div className="col-12">
                                            <WaitingOnOthers
                                                proxySource={EPIC}
                                                grantEpicExpiredList={grantEpicExpiredList} />
                                        </div>
                                    </div>
                                }

                            </MedicalManagers>
                        }

                        {
                            epicManagerFailure &&
                            <ErrorMsg
                                message="We are not able to show your managers. Please try again later."
                            />
                        }
                        </FamilyManagementCard>

                    </>
                }
                <FamilyManagementCard title="BSW Pharmacy">
                    <RXManagers
                        showNoManagers={(hasPharmacyLogin
                            ? showGrantProxyAccess
                                ? enableProxyGrantPharmacy
                                    ? (!hasGrantPharmacyActiveList && !hasPendingGrantPharmacyList && !hasCancelledGrantPharmacyList && !hasDeclinedGrantPharmacyList && !hasExpiredGrantPharmacyList && !hasPendingList && !hasActiveList && !pharmacyError)
                                    : (!hasPendingList && !hasActiveList && !pharmacyError && !hasRequestRxCancelledList && !hasRequestRxExpiredList)
                                : (!hasPendingList && !hasActiveList && !pharmacyError && !hasRequestRxCancelledList && !hasRequestRxExpiredList)
                            : false
                        )}
                    >
                        {hasActiveList &&
                            <div className="row active-list-container">
                                <div className="col-12">
                                    <ActiveList
                                        requestList={activeList}
                                        proxySource={RX}
                                        referrer="proxy"
                                        approvedRequest={this.approvedRequest}
                                        isApprovePending={isChangeRequestActionApproveWaiting}
                                        approveRequestId={approveRequestId}
                                        approvedRequestSuccess={approvedRequestSuccess}
                                        actionType={actionType}
                                    />
                                </div>
                            </div>
                        }

                        {enableProxyGrantPharmacy && hasPharmacyLogin && hasGrantPharmacyActiveList &&
                            <div className="row active-list-container">
                                <div className="col-12">
                                    <ActiveList grantOrManagerList={grantPharmacyActiveList} proxySource={RX} referrer="acceptgrant" />
                                </div>
                            </div>
                        }
                        {((enableProxyRXRequestAttestation || hasPharmacyLogin) && hasPendingList) &&
                            <div className="row pending-list-container">
                                <div className="col-12">
                                    <WaitingOnYou
                                        list={pendingList}
                                        onApprove={request => this.onApprove(request)}
                                        onDecline={request => this.onDecline(request)}
                                        proxySource={RX}
                                        isApprovePending={isChangeRequestActionApproveWaiting}
                                        approveRequestId={approveRequestId}
                                        approveErrorMessage={approveErrorMessage}
                                        isDeclinePending={isChangeRequestActionDeclineWaiting}
                                        declineRequestId={declineRequestId}
                                        declineErrorMessage={declineErrorMessage}
                                        actionType={actionType}
                                        history={this.props.history}
                                    />
                                </div>
                            </div>
                        }
                        {
                            showGrantProxyAccess && enableProxyGrantPharmacy && hasPharmacyLogin && hasPendingGrantPharmacyList &&
                            <div className="row pending-list-container">
                                <div className="col-12">
                                    <WaitingOnOthers
                                        proxySource={RX}
                                        grantPharmacyPendingList={pendingGrantPharmacyList} />
                                </div>
                            </div>
                        }
                        {
                            showGrantProxyAccess && enableProxyGrantPharmacy && hasPharmacyLogin && hasCancelledGrantPharmacyList &&
                            <div className="row cancelled-list-container">
                                <div className="col-12">
                                    <WaitingOnOthers
                                        proxySource={RX}
                                        grantPharmacyCancelledList={cancelledGrantPharmacyList} />
                                </div>
                            </div>
                        }

                        {/* request v2 pharmacy cancelled */}
                        {
                            enableProxyRequestV2 && hasPharmacyLogin && hasRequestRxCancelledList &&
                            <div className="row cancelled-list-container">
                                <div className="col-12">
                                    <WaitingOnYou
                                        proxySource={RX}
                                        hasRequestRxCancelledList={hasRequestRxCancelledList}
                                        requestRxCancelledList={requestRxCancelledList} />
                                </div>
                            </div>
                        }
                        {/* request v2 pharmacy declined */}
                        {/* enableProxyRequestV2 && hasPharmacyLogin && hasRequestRxDeclinedList &&
                            <div className="row declined-list-container">
                                <div className="col-12">
                                    <WaitingOnYou
                                        proxySource={RX}
                                        hasRequestRxDeclinedList={hasRequestRxDeclinedList}
                                        requestRxDeclinedList={requestRxDeclinedList} />
                                </div>
                            </div>
                        */}

                        {
                            showGrantProxyAccess && enableProxyGrantPharmacy && hasPharmacyLogin && hasDeclinedGrantPharmacyList &&
                            <div className="row declined-list-container">
                                <div className="col-12">
                                    <WaitingOnOthers
                                        proxySource={RX}
                                        grantPharmacyDeclinedList={declinedGrantPharmacyList} />
                                </div>
                            </div>
                        }
                        {/* request v2 pharmacy expired */}
                        {enableProxyRequestV2 && hasPharmacyLogin && hasRequestRxExpiredList &&
                            <div className="row declined-list-container">
                                <div className="col-12">
                                    <WaitingOnYou
                                        proxySource={RX}
                                        hasRequestRxExpiredList={hasRequestRxExpiredList}
                                        requestRxExpiredList={requestRxExpiredList} />
                                </div>
                            </div>
                        }

                        {showGrantProxyAccess && enableProxyGrantPharmacy && hasPharmacyLogin && hasExpiredGrantPharmacyList
                            && <div className="row declined-list-container">
                                <div className="col-12">
                                    <WaitingOnOthers
                                        proxySource={RX}
                                        grantExpiredPharmacyList={expiredGrantPharmacyList} />
                                </div>
                            </div>
                        }

                    </RXManagers>

                    {!hasPharmacyLogin && 
                        <LinkRecord
                            to={{
                                pathname: '/linkedaccounts',
                                searchParams: "openPharmacy=true"
                            }}
                        />
                    }

                    {emailProxyRequestErrMsg &&
                        <ErrorMsg message={proxyErrorMsg} />
                    }
                    {
                        pharmacyError &&
                        <ErrorMsg
                            message="We are not able to show your managers. please try again later."
                        />
                    }
                </FamilyManagementCard>
                {age > 17 && showGrantProxyAccess && ((hasPharmacyLogin && enableProxyGrantPharmacy) || hasMychartLogin) &&
                    <> <Button onClick={this.grantAccess}>Grant Access</Button>
                        {this.state.showGrantDisclaimerModal &&
                            <GrantDisclaimerModal
                                isOpen
                                enableCloseButton
                                onAgreeGrantDisclaimer={this.onAgreeGrantDisclaimer}
                                healthrecord={hasMychartLogin}
                                pharmacy={hasPharmacyLogin}
                                fromProxyLanding
                            />
                        }
                        {/*<Link className="btn btn-primary grant-access-btn" to={{ pathname: "/grantaccessProxy" }}>GRANT ACCESS</Link>*/}
                    </>
                }
                {(isChangeRequestActionApproveWaiting) &&
                    <>
                        <div className="row">
                            <div className="col-12 align-self-center">
                                <Spinner />
                            </div>
                        </div>
                    </>
                }
            </div>
        ));
    }
}

const mapStateToProps = (state) => {
    return {
        emailProxyRequestId: state.common.emailProxyRequestId,
        emailProxyRequestErrMsg: state.common.emailProxyRequestErrMsg,
        proxySource: state.common.proxySource,
        requestType: state.common.requestType,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        hasMychartLogin: !state.common.epicEHRDown && state.domain.hm,
        showAccessAndProxiesList: state.session.serverData && state.session.serverData.ShowAccessAndProxiesList,
        changeRequestStatusAction: state.common[types.REQUEST_PROXY_CHANGE_STATUS],
        age: state.domain.age,
        showGrantProxyAccess: state.session.serverData ? state.session.serverData.showGrantProxyAccess : false,
        declineProxyWithReason: state.session.serverData ? state.session.serverData.declineProxyWithReason : false,
        enableProxyGrantPharmacy: state.session.serverData ? state.session.serverData.enableProxyGrantPharmacy : false,
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        enableProxyRXRequestAttestation: state.session.serverData ? state.session.serverData.enableProxyRXRequestAttestation : false
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeRequestStatus: (proxyRequestId, proxySource, requestType, status) =>
            dispatch({ type: types.REQUEST_PROXY_CHANGE_STATUS, data: { proxyRequestId, proxySource, requestType, status } }),
        setTimeoutMessage: (actionType) => dispatch({ type: types.SET_PROXY_MESSAGE, data: { actionType } }),
        clearMessage: () => dispatch({ type: types.CLEAR_PROXY_MESSAGE })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyProxies));